export default __webpack_public_path__ + "static/media/repayment-channel-bg.1ce0d70d.png";